// import Signin from "pages/signin/signin";
import Login from "./login/login";
import StoreTeacherLogin from "./login/storeTeacherLogin";
import StoreGuestLogin from "./login/storeGuestLogin";
import StoreStudentLogin from "./login/storeStudentLogin";
import SignupCouncellor from "./signup/signupcounsellor";
import SignupGuest from "./signup/signupguest";
import SignupStudent from "./signup/signupstudent";
import SignupTeacher from "./signup/signupteachers";

export const auth_routes = [
  // login-route
  {
    path: "/login-guest",
    Component: <Login userType="guest" navigateTo="/dashboard/home" />,
    layout: false,
  },
  {
    path: "/login-student",
    Component: <Login userType="student" navigateTo="/dashboard/home" />,
    layout: false,
  },
  {
    path: "/login-teacher",
    Component: <Login userType="teacher" navigateTo="/dashboard/home" />,
    layout: false,
  },
  {
    path: "/login-counsellor",
    Component: <Login userType="counsellor" navigateTo="/counsellors" />,
    layout: false,
  },
  // store
  {
    path: "/store-login-student",
    Component: (
      <StoreStudentLogin userType="student" navigateTo="/shopping-cart" />
    ),
    layout: false,
  },
  {
    path: "/store-login-guest",
    Component: <StoreGuestLogin userType="guest" navigateTo="/shopping-cart" />,
    layout: false,
  },
  {
    path: "/store-login-teacher",
    Component: (
      <StoreTeacherLogin userType="teacher" navigateTo="/shopping-cart" />
    ),
    layout: false,
  },

  //   sign up route
  { path: "/signup-student", Component: <SignupStudent />, layout: false },
  { path: "/signup-teacher", Component: <SignupTeacher />, layout: false },
  {
    path: "/signup-counsellor",
    Component: <SignupCouncellor />,
    layout: false,
  },
  { path: "/signup-guest", Component: <SignupGuest />, layout: false },
];
